import React, { useState } from 'react';
import { AdminGroup, AdminTemplate } from '../../types/types';
import { ROLES, getRoleDisplayName } from '../../utils/roleUtils';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  groups: AdminGroup[];
  onConfirm: (selectedGroupId: string, selectedRole: string) => void;
}

export const GroupsModal: React.FC<ModalProps> = ({ isOpen, onClose, groups, onConfirm }) => {
  const [selectedGroup, setSelectedGroup] = useState<string>(groups[0].group_id);
  const [selectedRole, setSelectedRole] = useState<string>(ROLES.CLINICIAN);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedGroup(event.target.value);
  };

  const handleChangeRole = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedRole(event.target.value);
  };

  const handleConfirm = () => {
    onConfirm(selectedGroup, selectedRole);
  };

  const handleOverlayClick = (event: any) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen" onClick={handleOverlayClick}>
        <div className="bg-white p-4 rounded-lg text-left overflow-hidden shadow-xl">
          <h3 className="text-lg leading-6 font-medium text-gray-900 mb-3">Select a group</h3>
          <select
            value={selectedGroup}
            onChange={handleChange}
            className="block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            {groups.map(group => (
              <option key={group.group_id} value={group.group_id}>
                {group.group_info?.name}
              </option>
            ))}
          </select>
          <select
            value={selectedRole}
            onChange={handleChangeRole}
            className="block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value={ROLES.CLINICIAN}>{getRoleDisplayName(ROLES.CLINICIAN)}</option>
            <option value={ROLES.OPERATIONS_SUPPORT}>{getRoleDisplayName(ROLES.OPERATIONS_SUPPORT)}</option>
            <option value={ROLES.PRACTICE_ADMINISTRATOR}>{getRoleDisplayName(ROLES.PRACTICE_ADMINISTRATOR)}</option>
            <option value={ROLES.SUPERVISOR}>{getRoleDisplayName(ROLES.SUPERVISOR)}</option>
            <option value={ROLES.BILLING_ADMINISTRATOR}>{getRoleDisplayName(ROLES.BILLING_ADMINISTRATOR)}</option>
          </select>
          <div className="mt-5 sm:mt-3 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              className="ml-3 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              onClick={handleConfirm}
            >
              Confirm
            </button>
            <button
              type="button"
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
